module.exports = __webpack_public_path__ + "img/chen_lw.972899ee.png";